(function(){if(typeof window>"u")return;const root=document.documentElement;let ticking=!1,pastHero=!1;function update(){const scrollY=window.scrollY||window.pageYOffset||0,transitionZone=window.innerHeight*.55,progress=Math.max(0,Math.min(scrollY/transitionZone,1));root.style.setProperty("--header-scroll-progress",progress.toFixed(4));const shouldBePast=progress>=.5;shouldBePast!==pastHero&&(pastHero=shouldBePast,document.body.classList.toggle("kaf-past-hero",pastHero)),ticking=!1}function onScroll(){ticking||(window.requestAnimationFrame(update),ticking=!0)}window.addEventListener("scroll",onScroll,{passive:!0}),window.addEventListener("resize",onScroll,{passive:!0}),update()})();
//# sourceMappingURL=/cdn/shop/t/10/assets/kaf-header-scroll.js.map

/* KAF cart-badge pop — fires the .kaf-pop animation whenever the cart
   count bubble changes (adds from PDP, set builder, quick-add, drawer). */
(function () {
  if (typeof window === 'undefined') return;
  var armed = null;
  function pop(icon) {
    icon.classList.remove('kaf-pop');
    void icon.offsetWidth; /* restart animation */
    icon.classList.add('kaf-pop');
    setTimeout(function () { icon.classList.remove('kaf-pop'); }, 650);
  }
  function arm() {
    var icon = document.querySelector('.header-actions__cart-icon');
    var bubble = icon && icon.querySelector('.cart-bubble');
    if (!icon || !bubble || bubble === armed) return;
    armed = bubble;
    var mo = new MutationObserver(function () { pop(icon); });
    mo.observe(bubble, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }
  function init() {
    arm();
    /* Horizon can re-render the header node — re-arm on cart events */
    document.addEventListener('cart:update', function () { setTimeout(arm, 300); });
    document.addEventListener('CartUpdateEvent', function () { setTimeout(arm, 300); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
